import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import moment from 'moment';

export default function SupplierContractTermOverduesIndex() {
    const [overdues, setOverdues] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => fetchOverdues(), []);

    const fetchOverdues = () => {
        setIsLoading(true);
        axios
            .get(FetchSupplierContractsTermOverduesUrl)
            .then(({ data }) => setOverdues(data))
            .catch((error) => {})
            .finally(() => setIsLoading(false));
    };

    if (isLoading) {
        return <Loading />;
    } else if (!overdues) {
        return <div className="text-danger">{$t('Something went wrong')}.</div>;
    } else if (!overdues?.length) {
        return <div className="text-info">{$t("There's no overdue milestones")}</div>;
    }

    return (
        <div className="suppliers-table table-responsive shadow">
            <table className="table table-bordered no-footer text-center m-0 font-weight-bold">
                <thead>
                    <tr className={'text-blue bg-white'}>
                        <th style={{ width: '10%' }} className="border-top-0 border-left-0">
                            {$t('Contract')}
                        </th>
                        <th style={{ width: '10%' }} className="border-top-0 border-left-0">
                            {$t('Contract Owner')}
                        </th>
                        <th style={{ width: '60%' }} className="border-top-0 border-left-0">
                            {$t('Description')}
                        </th>
                        <th style={{ width: '20%' }} className="border-top-0 border-right-0">
                            {$t('Due Date')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {overdues.map((overdue) => {
                        return (
                            <tr key={overdue.id} className="bg-grey2">
                                <td className="border-bottom-0 border-left-0">{overdue.term?.contract?.contract_reference}</td>
                                <td className="border-bottom-0">
                                    {overdue.term.owner?.first_name} {overdue.term.owner?.last_name}
                                </td>
                                <td className="border-bottom-0">{overdue.description}</td>
                                <td className="border-bottom-0 border-right-0">{moment(overdue.due_date).format('YYYY-MM-DD')}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

function Loading() {
    return (
        <div className="row my-2">
            <div className="col-12 d-flex align-items-center justify-content-center text-blue">
                <div
                    className="spinner-border"
                    style={{
                        width: '2rem',
                        height: '2rem',
                    }}
                    role="status"
                >
                    <span className="sr-only">{$t('Loading')}...</span>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('SupplierContractTermOverdues')) {
    var rootEl = document.getElementById('SupplierContractTermOverdues');
    ReactDOM.render(
        <App>
            <SupplierContractTermOverduesIndex />
        </App>,
        rootEl,
    );
}
